export const columnsDSChuyenKhoa = [
	{
		title: 'Tên dịch vụ',
		field: 'name',
		className: 'spaces width-40',
		render: (rowData: any) => {
			return rowData?.isCancel ? (
				<div className="d-flex">
					<i className={`bi bi-ban icon-ban spaces min-w-15 mr-10`}></i>
					<div className={`${rowData?.isCancel ? 'text-danger' : ''}`}>
						{rowData?.name}
					</div>
				</div>
			) : (
				<div className={`${rowData?.isCancel ? 'text-danger' : ''}`}>{rowData?.name}</div>
			);
		},
	},
	{
		title: 'SL',
		field: 'quantity',
		className: 'spaces width-10 text-center',
		render: (rowData: any) => {
			const DEFAULT_QUANTITY = rowData?.isCancel ? 0 : 1;
			return (
				<div className={`${rowData?.isCancel ? 'text-danger' : ''}`}>
					{DEFAULT_QUANTITY}
				</div>
			);
		},
	},
	{
		title: 'Kết quả',
		field: 'ketQua',
		className: 'spaces width-20',
		render: (rowData: any) => {
			return (
				<span
					className={`d-flex align-items-center spaces h-30 ${
						rowData?.isCancel ? 'text-danger' : ''
					}`}
				>
					{rowData?.obs?.value || ''}
				</span>
			);
		},
	},
	{ title: 'Loại bệnh phẩm', field: 'type', className: 'spaces width-15' },
	{
		title: 'Đối tượng',
		field: 'doiTuong',
		className: 'spaces width-15',
		render: (rowData: any) => {
			return (
				<div className={`${rowData?.isCancel ? 'text-danger' : ''}`}>
					{rowData?.objectTypeName || ''}
				</div>
			);
		},
	},
];
